import { render, staticRenderFns } from "./ed-homework-teacher-section-list.vue?vue&type=template&id=6a66edfa&scoped=true&"
import script from "./ed-homework-teacher-section-list.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-teacher-section-list.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-teacher-section-list.scss?vue&type=style&index=0&id=6a66edfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66edfa",
  null
  
)

export default component.exports